export function ListSkeleton() {
  return (
    <ul role="list" className="divide-y divide-gray-200">
      {[...Array(8)].map((_, i) => (
        <li key={i} className="relative bg-white px-4 py-5">
          <div className="relative flex items-center space-x-3">
            <div className="flex-shrink-0">
              <div className="h-24 w-32 animate-pulse rounded bg-gray-300"></div>
            </div>
            <div className="flex-1">
              <div className="flex">
                <div className="flex-1">
                  <div className="h-6 animate-pulse rounded bg-gray-300"></div>
                  <div className="mt-2 h-6 animate-pulse rounded bg-gray-300"></div>
                </div>
              </div>
              <div className="mt-2">
                <div className="h-6 animate-pulse rounded bg-gray-300"></div>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}
